import React from 'react';
import { Form, Input } from 'antd';

const TripInterval = () => {
    return (
        <Form.Item
            label="Czas pomiędzy kolejnymi spływami"
            name="tripIntervalMinutes"
        >
            <Input addonAfter="minut" style={{ maxWidth: 100 }} />
        </Form.Item>
    );
};

export default TripInterval;
